<template>
  <v-container fluid>
    <div>
      <div v-if="loading">
        <div class="grid">
          <PersonContentLoader />
          <PersonContentLoader />
          <PersonContentLoader />
          <PersonContentLoader />
          <PersonContentLoader />
          <PersonContentLoader />
          <PersonContentLoader />
          <PersonContentLoader />
          <PersonContentLoader />
        </div>
      </div>
      <div v-else>
        <div class="grid" v-if="nurses.length > 0">
          <div v-for="nurse in nurses" v-bind:key="nurse.id">
            <Person
              @select-person="selectNurse(nurse)"
              @edit-person="$modal.show('menu-modal' + nurse.id)"
              :person="nurse"
              :disabled="!canSelectNurse(nurse)"
              :no-link="$store.getters.user.role !== 'a'"
            />
            <modal
              class="menu"
              :name="'menu-modal' + nurse.id"
              width="100%"
              height="auto"
            >
              <ListItem
                :last="nurse.id === $store.getters.user.id"
                border="1px solid #31b9be"
                @click.native="
                  redirect(`/dashboard/nurse/create?nurseId=${nurse.id}`)
                "
                >{{ nurse.nickName }}
                {{ $t("dash.dictionary.tags.edit") }}</ListItem
              >
              <ListItem
                v-if="nurse.id !== $store.getters.user.id"
                last="true"
                border="1px solid #31b9be"
                @click.native="deleteNurse(nurse.id)"
                >{{ nurse.nickName }}
                {{ $t("dash.dictionary.tags.delete") }}</ListItem
              >
            </modal>
          </div>
        </div>
        <div v-else>
          <p>{{ $t("dash.nurse.not-found") }}</p>
        </div>
        <h3
          @click="collapseContent('archive')"
          v-if="archivedNurses.length > 0"
        >
          {{ $t("dash.nurse.archivedStaff") }}
          <img
            :src="
              require(`@/assets/icons/${
                archiveIsCollapsed ? 'arrow-up-pink.svg' : 'arrow-down-pink.svg'
              }`)
            "
            class="icon"
          />
        </h3>
        <div
          id="archive-content"
          class="grid content-closed"
          v-if="archivedNurses.length > 0"
        >
          <div
            v-for="nurse in archivedNurses"
            v-bind:key="nurse.id"
            class=""
          >
            <Person
              :class="{
                'archived-person': nurse.isArchived
              }"
              @edit-person="$modal.show('menu-modal' + nurse.id)"
              :no-link="($store.getters.user.hospital.multiAccountSupport) || ($store.getters.user.role !== 'a' && nurse.id !== $store.getters.user.id)"
              :person="nurse"
            />
            <modal
              class="menu"
              :name="'menu-modal' + nurse.id"
              width="100%"
              height="auto"
            >
              <ListItem
                last="true"
                border="1px solid #31b9be"
                @click.native="reactivateNurse(nurse)"
              >{{ nurse.nickName }}
                {{ $t("dash.nurse.reactivate") }}</ListItem
              >
            </modal>
          </div>
        </div>

      </div>
      <div class="fab-container no-tab">
        <Button
          v-if="this.$store.getters.user.role === 'a' && (!this.$store.getters.user.hospital.epdSettings || !this.$store.getters.user.hospital.epdSettings.epdEnabled)"
          class="fab"
          title
          color="#fff"
          bgcolor="#00A9B3"
          width="42px"
          height="42"
          margin="0"
          padding="0"
          icon="plus-white"
          @click.native="redirect('/dashboard/nurse/create')"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import { neoparentNurses } from "@/api";

export default {
  name: "neoparent-nurses",
  computed: {
  },
  data() {
    return {
      loading: true,
      nurses: [],
      archivedNurses: [],
      archiveIsCollapsed: false
    };
  },
  mounted() {
    window.oncontextmenu = function(event) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    };
    this.getNurses();
    this.getArchivedNurses();
  },
  methods: {
    canSelectNurse(nurse) {
      if (this.$store.getters.user.hospital.epdSettings && this.$store.getters.user.hospital.epdSettings.epdEnabled && nurse.id !== this.$store.getters.user.id) {
        return false;
      }
      if (!this.$store.getters.user.hospital.multiAccountSupport) {
        return nurse.id === this.$store.getters.user.id;
      }
      return true;
    },
    collapseContent(tag) {
      document
        .getElementById(`${tag}-content`)
        .classList.toggle("content-closed");
      this.archiveIsCollapsed = !this.archiveIsCollapsed;
    },
    getNurses() {
      neoparentNurses
        .getAllNurses(this.$store.getters.user.hospital.id)
        .then(result => {
          this.consoleLog(result);
          this.nurses = this.parseNurseData(result.data.nurses);
          this.loading = false;
        })
        .catch(err => {
          this.consoleLog(err);
        });
    },
    getArchivedNurses() {
      neoparentNurses
        .getAllArchivedNurses(this.$store.getters.user.hospital.id)
        .then(result => {
          this.consoleLog(result);
          this.archivedNurses = this.parseNurseData(result.data.nurses);
          this.loading = false;
        })
        .catch(err => {
          this.consoleLog(err);
        });
    },
    deleteNurse(id) {
      const that = this
      if (confirm(this.$t("dash.nurse.confirmArchivation"))) {
        neoparentNurses
          .deleteNurse(id)
          .then(result => {
            that.consoleLog(result);
            that.getNurses();
            that.getArchivedNurses()
          })
          .catch(err => {
            that.consoleLog(err);
          });
      }
    },
    reactivateNurse(nurse) {
      const that = this

        neoparentNurses
          .reactivateNurse(nurse)
          .then(result => {
            that.consoleLog(result);
            that.getNurses();
            that.getArchivedNurses()
          })
          .catch(err => {
            that.consoleLog(err);
          });
    },
    selectNurse(nurse) {
      this.$store.commit('updateNurse', nurse)
      window.location.href = `/dashboard/nurse/${nurse.id}/patients`;
    },
    parseNurseData(nurses) {
      let parsedNurses = [];

      nurses.forEach(nurse => {
        parsedNurses.push(nurse);
      });

      return parsedNurses;
    }
  }
};
</script>

<style scoped lang="scss">
.grid {
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 48px;
  display: grid;
  justify-content: center;
  width: 90%;
  margin: 48px auto;

  @media (min-width: 500px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 700px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 900px) {
    grid-template-columns: repeat(4, 1fr);
  }
}

.grid a {
  margin: 25px;
  width: 100px;
}

.nurse-card {
  margin: 0 auto;
  width: 150px;
}

.icon {
  width: 42px;
  vertical-align: middle;
}
</style>
